export enum Role {
    ADMIN = "ROLE_ADMIN",
    USER = "ROLE_USER",
}
